import {
  PROXY_FRAME_PATH_MAX_LENGTH,
  PROXY_FRAME_PATH_PATTERN,
  PROXY_READY_MESSAGE,
  PROXY_ROUTE_MESSAGE,
  PROXY_UUID_PATTERN,
} from '../constants';

interface ProxyReadyMessage {
  type: typeof PROXY_READY_MESSAGE;
  nonce: string;
}

interface ProxyRouteMessage {
  type: typeof PROXY_ROUTE_MESSAGE;
  path: string;
}

const isMessageRecord = (data: unknown): data is Record<string, unknown> =>
  typeof data === 'object' && data !== null;

export const isProxyFramePath = (path: unknown): path is string =>
  typeof path === 'string' &&
  path.length <= PROXY_FRAME_PATH_MAX_LENGTH &&
  PROXY_FRAME_PATH_PATTERN.test(path);

export const isProxyReadyMessage = (data: unknown): data is ProxyReadyMessage =>
  isMessageRecord(data) &&
  data.type === PROXY_READY_MESSAGE &&
  typeof data.nonce === 'string' &&
  PROXY_UUID_PATTERN.test(data.nonce);

export const isProxyRouteMessage = (data: unknown): data is ProxyRouteMessage =>
  isMessageRecord(data) &&
  data.type === PROXY_ROUTE_MESSAGE &&
  isProxyFramePath(data.path);
